export enum QueryFilterDialogType {
  MANAGE_FILTERS,
  SAVE_NEW,
  EDIT_EXISTING,
  PICK_FILTER
}
